import { useEffect } from 'react';
import { STORAGE_KEYS } from '../constants/storageKeys';

export const useOrganizationChangeListener = () => {
  useEffect(() => {
    // Track the last known organizationID to detect changes
    let lastOrgId = localStorage.getItem(STORAGE_KEYS.ORGANIZATION_ID);

    const onStorage = event => {
      // Early return if not organization-related storage event
      if (event.key !== STORAGE_KEYS.ORGANIZATION_ID) {
        return;
      }

      // Handle organization change - only reload background/hidden tabs
      if (
        event.newValue &&
        event.newValue !== lastOrgId &&
        document.visibilityState !== 'visible'
      ) {
        console.debug('[Organization] changed', { lastOrgId, newOrgId: event.newValue });
        window.location.reload();
      }

      // Handle logout scenario - organization removed and we had one before
      if (!event.newValue && lastOrgId) {
        console.debug('[Organization] logged out', { lastOrgId });
        window.location.reload();
        return;
      }

      // Update cache for future comparisons
      lastOrgId = event.newValue;
    };

    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener('storage', onStorage);
    };
  }, []);
};
